import { NgModule } from '@angular/core';
import { CookieModule } from 'ngx-cookie';

@NgModule({
  imports: [
    CookieModule.withOptions()
  ]
})
export class InterceptorModule { }

